<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
#app {
  width: 100%;
  min-height: 100vh;
  max-width: 640px;
  margin: 0 auto;
  background-color: #fff;
  position: relative;
  overflow-x: hidden;
}
</style>
